import { Config } from "react-translator-component";
import * as myConstClass from "../constant.js";

// Single source of truth for the translator language list. Every file that
// used to set Config.list imports this instead, so they can't overwrite
// each other.
const LANGUAGES = {
  en: { text: "English", file: require("./en.js") },
  KH: { text: "Khmer", file: require("./KH.js") },
  Mal: { text: "Malaysian", file: require("./Mal.js") },
  ch: { text: "Chinese", file: require("./ch.js") },
  HI: { text: "Hindi", file: require("./HI.js") },
  TA: { text: "Tamil", file: require("./TA.js") },
  MR: { text: "Marathi", file: require("./MR.js") },
};

// Languages offered per COUNTRY (from constant.js). LOCAL shows all languages.
const LANGUAGES_BY_COUNTRY = {
  KH: ["en", "KH", "ch"],
  MY: ["en", "Mal", "ch"],
  IN: ["en", "HI", "TA", "MR"],
};

const countryLanguages =
  (!myConstClass.IS_LOCAL && LANGUAGES_BY_COUNTRY[myConstClass.COUNTRY]) ||
  Object.keys(LANGUAGES);

Config.list = countryLanguages.reduce((list, key) => {
  list[key] = LANGUAGES[key];
  return list;
}, {});

// Fall back to English if the saved language isn't offered for this country.
if (!Config.list[localStorage.getItem("lang")]) {
  localStorage.setItem("lang", "en");
}
Config.default = localStorage.getItem("lang");
